import React from 'react';
import {
  Stat,
  Text,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  StatGroup,
  Card,
  CardBody,
  Container,
  useColorModeValue,
  ChakraProvider,
  Image,
  Box,
} from '@chakra-ui/react';
import Graph from '../Graph';

import SidebarWithHeader from '../SidebarWithHeader';
const Success = () => {
    const textColor = useColorModeValue('black', 'white');

  return (
    <div
    style={{
      display: "flex",
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      height: "80vh",
   
      flexDirection: "column",
      position: "relative",
    }}
  >
   

    <text
      style={{
        textAlign: "center",
        color: textColor,
        fontSize: 18,
        fontWeight: "bold",
      }}
    >
      Video uploaded successfully.
    </text>
    <text
      style={{
        textAlign: "center",
        color: textColor,
        fontSize: 18,
        fontWeight: "normal",
      }}
    >
      Thank you ❤️
    </text>
   
  </div>
  );
};

export default Success;
